export default {
    subject: "活動場次",
    round: {
        subject: `<span class="ft-14">第</span> %s <span class="ft-14">場</span>`
    },
    during: {
        subject: "%s 至 %s",
    }
}
